import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, of } from 'rxjs';
import { environment } from 'src/app/core/environments/environment';
import { MockedPaymentService } from '../mocks/payment.service.mock';
import { PaymentPageUtils } from '../utils/payment-page.utils';
import { PaymentServiceRoutes } from './payment.routes';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private HttpClient: HttpClient,
  ) { }

  getFlightOffer(flightOfferId: string) { //TODO: complete types and get it as props
    // return this.HttpClient.get(`${environment.ms_flights_base_url}/${PaymentServiceRoutes.Flight_Search}/${PaymentServiceRoutes.Updated_Flight_Offer}/${flightOfferId}`).pipe(map((res: any) => res));;
    
    return of(MockedPaymentService.getFlightOffer.response);
  }

  orderFlight(flightOffer: any, orderInformation: any[]) { //TODO: complete types and get it as props
    const flightOrderQuery = PaymentPageUtils.buildFlightOrderRequestPayload(flightOffer, orderInformation);
    const order = this.HttpClient.post(`${environment.ms_flights_base_url}/${PaymentServiceRoutes.Flight_Search}/${PaymentServiceRoutes.Create_Order}`, flightOrderQuery).pipe(map((res: any) => res));
    return order;
  }
}
